<template>
  <div id="app">
    <dynamic-router />
    <login-modal />
    <upload-kosiwon-modal />
    <full-indicator />
  </div>
</template>

<style>
#app {
  /*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  height: 100%;
}
</style>
<script>
  import DynamicRouter from './core/components/DynamicRouter'
  import LoginModal from './components/Modal/LoginModal'
  import UploadKosiwonModal from './components/Modal/UploadKosiwonModal'
  import FullIndicator from './components/Indicator/FullIndicator'
  export default {
    components: {FullIndicator, LoginModal, UploadKosiwonModal, DynamicRouter }
  }
</script>
